export default __webpack_public_path__ + "static/media/edit.cdc09ce6.svg";